import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import AddressFields from './address-fields/address-fields.component'
import { Form, Formik } from 'formik'
import { addressFieldsSchema } from './address-fields/address-fields.schema'

const StyledButtonContainer = styled.div`
	margin-top: 5rem;
	display: flex;
	justify-content: flex-end;
`
const initialValues = {
	state: '',
	city: ''
}

export default class AddressForm extends React.Component {

	passwordFocus = () => {
		window.scrollTo(0, 385)
	}

	render() {
		const { onSubmit, onBack, onClick } = this.props

		return (
			<Formik
				initialValues={initialValues}
				ref={'form'}
				onSubmit={onSubmit}
				validationSchema={addressFieldsSchema}
				render={props => (
					<Form noValidate>
						<AddressFields {...props} />
						<StyledButtonContainer>
							<Button
								link
								type="button"
								onClick={() => {
									onBack && onBack()
								}}>
								Anterior
							</Button>
							<Button
								primary
								type="submit"
								onClick={() => {
									onClick && onClick(props.isValid)
									this.passwordFocus()
								}}>
								Avançar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

AddressForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
